export function getPersistentStorage(preferableTypeWeb = "localStorage"): any {
  if (process.browser) {
    if (preferableTypeWeb === "sessionStorage") {
      return sessionStorage;
    }
    return localStorage;
  }
  return {};
}
